import React, { useState } from 'react';

interface LoginProps {
  onLogin: (token: string) => void;
  apiUrl: string;
}

const Login: React.FC<LoginProps> = ({ onLogin, apiUrl }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const token = btoa(`${username}:${password}`);
      console.log('Attempting login to:', `${apiUrl}/api/stats`);
      const response = await fetch(`${apiUrl}/api/stats`, {
        headers: {
          'Authorization': `Basic ${token}`,
        },
      });

      console.log('Login response status:', response.status);
      if (response.ok) {
        onLogin(token);
      } else {
        const errorData = await response.json().catch(() => ({}));
        console.error('Login failed:', response.status, errorData);
        if (response.status === 401) {
          setError('Invalid username or password');
        } else if (response.status === 0 || response.status >= 500) {
          setError(`Failed to connect to server. Check if API is running at ${apiUrl}`);
        } else {
          setError(`Server error: ${response.status}`);
        }
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(`Failed to connect to server at ${apiUrl}. Check if the backend is running.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h1 className="text-2xl font-bold text-center mb-6">License Server Admin</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
              Username
            </label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div className="mb-6">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          {error && (
            <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;

